/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import jwt from '../../http/requests/auth/jwt/index.js'

import router from '../../router'
const localStorageKey = 'loggedIn'

const tokenExpiryKey = 'tokenExpiry'
export default {
  // JWT
  loginJWT ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      jwt.login(payload.userDetails.email, payload.userDetails.password)
        .then(response => {
          // If there's user data in response
          if (response.data.status) {

            this.tokenExpiry = new Date(Date.now() + (15 * 60 * 1000))
            localStorage.setItem(tokenExpiryKey, this.tokenExpiry)
            localStorage.setItem(localStorageKey, 'true')
            // Set accessToken
            localStorage.setItem('accessToken', response.data.token)

            // Update user details
            commit('UPDATE_USER_INFO', response.data.data, {root: true})

            // Set bearer token in axios
            commit('SET_BEARER', response.data.token)

            resolve(response)
          } else {
            reject({message: 'Wrong Email or Password'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  registerUserJWT ({ commit }, payload) {

    const password = payload.userDetails.password
    const confirmPassword = payload.userDetails.confirmPassword

    return new Promise((resolve, reject) => {

      // Check confirm password
      if (password !== confirmPassword) {
        reject({message: 'Password doesn\'t match. Please try again.'})
      }

      jwt.registerUser(payload)
        .then(response => {
          // Redirect User
          router.push({path:'/dashboard'})

          // Update data in localStorage
          //localStorage.setItem('accessToken', response.data.token)
          commit('UPDATE_USER_INFO', JSON.parse(localStorage.getItem('userInfo')), {root: true})

          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },
  fetchAccessToken () {
    return new Promise((resolve) => {
      jwt.refreshToken().then(response => { resolve(response) })
    })
  }
}
